<!--
 * @Author: gaozexiong RJgaozexiong@ruijie.com.cn
 * @Date: 2022-02-10 15:20:46
 * @LastEditors: gaozexiong RJgaozexiong@ruijie.com.cn
 * @LastEditTime: 2022-07-23 14:17:35
 * @FilePath: \ces-vue-serve\src\views\Chief\contract\common\InvoiceDetails.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div>
    <div style="margin: 0 0 20px">
      <el-button type="primary" :loading="exportLoading" @click="exportData">
        导出开票明细
      </el-button>
    </div>
    <div v-if="typeView === 'retrun'">
      <el-table v-loading="loading" :data="tableData" border style="width: 100%" :summary-method="getSummaries" show-summary>
        <el-table-column type="index" width="70" label="序号" align="left" />
        <el-table-column prop="kpNumber" label="金税发票号" align="left" />
        <el-table-column prop="kpDate" label="金税开票日期" align="left" />
        <el-table-column prop="productName" label="物品名称" align="left" />
        <el-table-column prop="invoiceCount" label="数量" align="left" width="70" />
        <el-table-column prop="invoicePrice" label="单价" align="right" header-align="left" width="80" />
        <el-table-column prop="kpAmountAccount" label="含税金额(本币)" align="right" header-align="left" />
        <el-table-column prop="untaxAmountAccount" label="不含税金额(本币)" align="right" header-align="left" />
        <el-table-column prop="invoiceType" label="发票类型" align="left" width="70" />
        <el-table-column prop="taxAccount" label="税率" align="right" header-align="left" width="70" />
        <el-table-column prop="courierNumber" label="发票快递单号" align="left" />
        <el-table-column
          prop="serviceDesc"
          label="服务备注"
          align="left"
          :v-if="contractType =='国际分销下单'"
        />
        <!-- <el-table-column prop="pname" label="发票下载" align="left" width="70">
          <template v-slot="{row}">
            <el-button type="text" @click="down(row)">
              下载
            </el-button>
          </template>
        </el-table-column> -->
      </el-table>
    </div>
    <div v-else>
      <el-table v-loading="loading" :data="tableData" border style="width: 100%" :summary-method="getSummaries" show-summary>
        <el-table-column type="index" width="70" label="序号" align="left" />
        <el-table-column prop="kpNumber" label="金税发票号" align="left" width="170" />
        <el-table-column prop="kpDate" label="金税开票日期" align="left" width="120" />
        <el-table-column prop="productName" label="商品名称" align="left" />
        <el-table-column prop="invoiceCount" label="发票数量" align="left" width="70" />
        <el-table-column prop="invoicePrice" label="发票单价" align="right" width="80" header-align="left" />
        <el-table-column prop="kpAmountAccount" label="含税金额(本币)" align="right" width="130" header-align="left" />
        <el-table-column prop="untaxAmountAccount" label="不含税金额(本币)" align="right" width="130" header-align="left" />
        <el-table-column prop="invoiceType" label="发票标记" align="left" width="100" />
        <el-table-column prop="taxAccount" label="税金" align="right" width="100" header-align="left" />
        <el-table-column prop="courierNumber" label="发票快递单号" align="left" />
        <el-table-column
          prop="serviceDesc"
          label="服务备注"
          align="left"
          :v-if="contractType =='国际分销下单'"
        />
        <!-- <el-table-column prop="pname" label="发票下载" align="left" width="70">
          <template v-slot="{row}">
            <el-button type="text" @click="down(row)">
              下载
            </el-button>
          </template>
        </el-table-column> -->
      </el-table>
    </div>
  </div>
</template>
<script type="es6">
import axios, { agGetInvoiceDetails, getInvoiceDetails } from '@/API';
import { downloadBlobFile } from '@/libs/util';
export default {
  props: {
    strContractCode: {
      type: String,
      required: true
    },
    contractId: {
      type: String,
      default: ''
    },
    contractType: {
      type: String,
      default: () => { return ''; }
    },
    typeView: {
      type: String,
      default: ''
    }
  },

  mounted () {
    this.initData();
  },

  data () {
    return {
      tableData: [],
      loading: false,
      exportLoading: false
    };
  },

  methods: {
    initData () {
      this.loading = true;
      if (this.typeView === 'return') {
        agGetInvoiceDetails({
          reContractId: this.contractId || ''
        }).then((res) => {
          let json = res.data;
          this.loading = false;
          if (json.status === '200') {
            this.tableData = json.data;
          }
        }).catch(() => {
          this.loading = false;
        });
      } else {
        getInvoiceDetails(this.strContractCode).then((res) => {
          let json = res.data;
          this.loading = false;
          if (json.status === '200') {
            this.tableData = json.data;
          }
        }).catch(() => {
          this.loading = false;
        });
      }
    },
    // 合计
    getSummaries (param) {
      const { columns } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (column.label === '含税金额(本币)') {
          sums[index] = this.kpAmount();
        }
      });
      return sums;
    },
    kpAmount () {
      let cont = 0;
      this.tableData.forEach((item) => {
        cont += Number(item.kpAmountAccount);
      });
      return cont.toFixed(2);
    },
    // 导出开票明细
    exportData () {
      this.exportLoading = true;
      axios.get('/export/getExporttInvoiceDetailsInfo?contractNum=' + this.strContractCode, {
        responseType: 'blob'// 服务器返回的数据类型
      }).then((res) => {
        this.exportLoading = false;
        downloadBlobFile({
          content: res.data,
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          fileName: '导出开票明细'
        });
      }).catch(() => {
        this.exportLoading = false;
      });
    },
    down (row) {
      console.log(row);
    }
  }
};
</script>
<style lang="less"></style>
